export async function getImageFileDimensions(file: File): Promise<{ width: number; height: number }> {
    return new Promise((resolve) => {
        const fr = new FileReader()

        fr.onload = function () {
            // file is loaded
            const img = new Image()

            img.onload = function () {
                resolve({ width: img.width, height: img.height })
            }
            img.src = fr.result as string // is the data URL because called with readAsDataURL
        }

        fr.readAsDataURL(file)
    })
}

export function getFileSizeStrInKb(sizeInBytes: number) {
    return Math.round(sizeInBytes / 100) / 10 + " kB"
}

export function getFilesFromInput(input: HTMLInputElement | null): File[] {
    if (!input || !input.files) {
        return []
    }

    const res: File[] = []
    const fileList = input.files
    for (let i = 0; i < fileList?.length; i++) {
        res.push(fileList[i])
    }

    return res
}

export function getFileType(fileName: string | undefined): string | undefined {
    const nameParts = (fileName ?? "").split(".")
    return nameParts[nameParts.length - 1]
}

export async function getFileAsText(readFile: File) {
    return new Promise((resolve) => {
        const reader = new FileReader()

        reader.readAsText(readFile, "UTF")

        reader.onload = (e) => {
            resolve(e.target?.result)
        }
    })
}

export function downloadJsonFile(data: any, name: string, compressed: boolean) {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data, undefined, compressed ? 0 : 2))
    const downloadAnchorNode = document.createElement("a")
    downloadAnchorNode.setAttribute("href", dataStr)
    downloadAnchorNode.setAttribute("download", name + ".json")
    document.body.appendChild(downloadAnchorNode) // required for firefox
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
}

export function downloadTextFile(data: string[], name: string) {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(data.join("\n"))
    const downloadAnchorNode = document.createElement("a")
    downloadAnchorNode.setAttribute("href", dataStr)
    downloadAnchorNode.setAttribute("download", name + ".txt")
    document.body.appendChild(downloadAnchorNode) // required for firefox
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
}

export function downloadCsvFile(data: string, name: string) {
    const dataStr = "data:text/csv;charset=utf-8," + encodeURIComponent(data)
    const downloadAnchorNode = document.createElement("a")
    downloadAnchorNode.setAttribute("href", dataStr)
    downloadAnchorNode.setAttribute("download", name + ".csv")
    document.body.appendChild(downloadAnchorNode) // required for firefox
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
}
